import { IconName } from "../../atoms";

export enum OrWidgetType {
  PERSONAL_STATS = 'personal-stats',
}

export interface OrWidgetPersonalStatsProps {
  variant: OrWidgetType.PERSONAL_STATS;
  title: string;
  icon: IconName;
  value: string;
  emptyMessage: string;
}

export type OrWidgetProps = OrWidgetPersonalStatsProps